import { FunctionComponent } from 'react';
import LazyLoadComponent from '@lib/lazy-component';
import Component from './dynamic';
import Placeholder from './placeholder';

export const LazyComponent = (props: any) => (
  <LazyLoadComponent
    {...props}
    component={Component}
    placeholder={Placeholder}
  />
);

export default LazyComponent;
